import React from 'react';
import { ReportStudioView } from 'src/components/star-grid/views/ReportStudioView';
import type { StudioImportableReport } from 'src/components/star-grid/hooks/useStudioTemplateChooser';

export interface CreateReportPageProps {
  readonly onCreated: (reportId: number, name?: string) => void;
  /** Saved reports offered as a starting point to copy from. Create only. */
  readonly importable?: readonly StudioImportableReport[];
}

export const CreateReportPage: React.FC<CreateReportPageProps> = ({ onCreated, importable }) => (
  <ReportStudioView onCreated={onCreated} importable={importable} />
);
